// extracted by mini-css-extract-plugin
module.exports = {"Conditions":"ExerciseStepCondition_Conditions__EeY7D","Wrong":"ExerciseStepCondition_Wrong__3o-yx","Right":"ExerciseStepCondition_Right__2mRTQ"};